var _defs, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperianLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79.84584 26.505831",
    id: "experianLogo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(122.91408,-181.93624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g135",
    transform: "translate(0.50000173,-0.49999809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m -110.4522,188.94228 h -2.88396 c -0.87312,0 -1.56104,-0.68792 -1.56104,-1.56104 v -2.88396 c 0,-0.84667 0.68792,-1.56104 1.56104,-1.56104 h 2.88396 c 0.84667,0 1.56104,0.68791 1.56104,1.56104 v 2.88396 c 0,0.87312 -0.68792,1.56104 -1.56104,1.56104",
    className: "st0",
    style: {
      fill: "#406eb3",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m -117.93991,195.42457 h -3.22792 c -0.97895,0 -1.74625,-0.79375 -1.74625,-1.74625 v -3.25438 c 0,-0.9525 0.79375,-1.74625 1.74625,-1.74625 h 3.25438 c 0.97896,0 1.74625,0.79375 1.74625,1.74625 v 3.25438 c 0,0.97896 -0.79375,1.74625 -1.77271,1.74625",
    className: "st1",
    style: {
      fill: "#632678",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m -118.23095,202.17144 h -1.98438 c -0.58208,0 -1.05833,-0.47625 -1.05833,-1.05833 v -1.98437 c 0,-0.58209 0.47625,-1.05834 1.05833,-1.05834 h 1.98438 c 0.58208,0 1.05833,0.47625 1.05833,1.05834 v 1.98437 c 0,0.58208 -0.47625,1.05833 -1.05833,1.05833",
    className: "st2",
    style: {
      fill: "#982881",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m -112.91283,208.44207 h -2.35479 c -0.68791,0 -1.27,-0.55563 -1.27,-1.27 v -2.35479 c 0,-0.68792 0.55563,-1.27 1.27,-1.27 h 2.35479 c 0.68792,0 1.27,0.55562 1.27,1.27 v 2.35479 c 0,0.71437 -0.55562,1.27 -1.27,1.27",
    className: "st3",
    style: {
      fill: "#ba2f7d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m -104.31387,190.1329 h -1.61396 c -0.47625,0 -0.87312,-0.39687 -0.87312,-0.87312 v -1.61396 c 0,-0.47625 0.39687,-0.87313 0.87312,-0.87313 h 1.61396 c 0.47625,0 0.87313,0.39688 0.87313,0.87313 v 1.61396 c 0.0265,0.47625 -0.37042,0.87312 -0.87313,0.87312",
    className: "st3",
    style: {
      fill: "#ba2f7d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m -68.700951,191.21769 c 0.529167,0 0.926042,-0.42333 0.926042,-0.92604 0,-0.52916 -0.423333,-0.92604 -0.926042,-0.92604 -0.529166,0 -0.9525,0.42333 -0.9525,0.92604 0,0.50271 0.423334,0.92604 0.9525,0.92604 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m -102.91158,201.21894 c -0.13229,0.21167 -0.37041,0.3175 -0.635,0.3175 -0.13229,0 -0.3175,-0.0265 -0.42333,-0.10583 -0.21167,-0.13229 -0.34396,-0.39687 -0.34396,-0.66146 0,-0.13229 0.0265,-0.26458 0.10584,-0.37041 l 2.16958,-3.41313 -2.16958,-3.41312 c -0.0794,-0.10584 -0.10584,-0.26459 -0.10584,-0.37042 0,-0.26458 0.13229,-0.52917 0.37042,-0.66146 0.13229,-0.0794 0.26458,-0.10583 0.39687,-0.10583 0.26459,0 0.50271,0.10583 0.66146,0.3175 l 1.77271,2.80458 1.799168,-2.80458 c 0.132292,-0.21167 0.396875,-0.3175 0.661458,-0.3175 0.132292,0 0.264584,0.0265 0.396875,0.10583 0.238125,0.13229 0.370417,0.39688 0.370417,0.66146 0,0.13229 -0.02646,0.26458 -0.105833,0.37042 l -2.169585,3.41312 2.169585,3.41313 c 0.07937,0.10583 0.105833,0.23812 0.105833,0.37041 0,0.26459 -0.132292,0.55563 -0.343958,0.66146 -0.132292,0.0794 -0.291042,0.10583 -0.423334,0.10583 -0.264583,0 -0.47625,-0.10583 -0.635,-0.3175 l -1.799166,-2.77812 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m -95.159284,193.46665 c 0.820209,-0.74083 1.931459,-1.19062 3.122083,-1.19062 2.619375,0 4.683125,2.09021 4.683125,4.68312 0,2.56646 -2.090208,4.65667 -4.683125,4.65667 -1.190624,0 -2.301874,-0.44979 -3.122083,-1.19063 v 3.99521 c 0,0.39688 -0.370416,0.74084 -0.767291,0.74084 -0.370417,0 -0.767292,-0.34396 -0.767292,-0.74084 v -11.32416 c 0,-0.39688 0.370417,-0.74084 0.767292,-0.74084 0.423333,0 0.767291,0.34396 0.767291,0.74084 z m 3.095625,0.37042 c -1.74625,0 -3.122083,1.37583 -3.122083,3.12208 0,1.74625 1.375833,3.12209 3.122083,3.12209 1.74625,0 3.122083,-1.37584 3.122083,-3.12209 0.02646,-1.74625 -1.349375,-3.12208 -3.122083,-3.12208 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m -74.098451,196.11249 v 4.68312 c 0,0.39688 -0.370416,0.74083 -0.767291,0.74083 -0.423334,0 -0.767292,-0.34395 -0.767292,-0.74083 v -7.69937 c 0,-0.39688 0.370417,-0.74084 0.767292,-0.74084 0.370416,0 0.740833,0.3175 0.767291,0.71438 0.635,-0.47625 1.455209,-0.76729 2.328334,-0.76729 0.47625,0 0.846666,0.37041 0.846666,0.76729 0,0.42333 -0.370416,0.79375 -0.846666,0.79375 -1.190625,0.0265 -2.328334,0.44979 -2.328334,2.24896 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m -68.700951,192.3554 c -0.423333,0 -0.767291,0.34396 -0.767291,0.74084 v 7.72583 c 0,0.39687 0.370416,0.74083 0.767291,0.74083 0.370417,0 0.767292,-0.34396 0.767292,-0.74083 v -7.72583 c 0,-0.39688 -0.370417,-0.74084 -0.767292,-0.74084 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m -58.858451,193.09624 c 0,-0.39688 0.370417,-0.74084 0.767292,-0.74084 0.370416,0 0.767291,0.34396 0.767291,0.74084 v 7.72583 c 0,0.39687 -0.370416,0.74083 -0.767291,0.74083 -0.423334,0 -0.767292,-0.34396 -0.767292,-0.74083 v -0.37042 c -0.846667,0.74084 -1.931458,1.19063 -3.122083,1.19063 -2.619375,0 -4.683125,-2.09021 -4.683125,-4.68313 0,-2.56646 2.090208,-4.65666 4.683125,-4.65666 1.190625,0 2.275416,0.44979 3.122083,1.19062 z m -3.122083,6.985 c 1.74625,0 3.122083,-1.37584 3.122083,-3.12209 0,-1.74625 -1.375833,-3.12208 -3.122083,-3.12208 -1.74625,0 -3.122084,1.37583 -3.122084,3.12208 0,1.74625 1.375834,3.12209 3.122084,3.12209 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m -49.465743,196.21832 c 0,-1.29646 -1.11125,-2.40771 -2.407708,-2.40771 -1.243542,0 -2.407708,0.50271 -2.407708,2.32833 v 4.68313 c 0,0.39687 -0.370417,0.74083 -0.767292,0.74083 -0.423333,0 -0.767292,-0.34396 -0.767292,-0.74083 v -7.72583 c 0,-0.39688 0.370417,-0.74084 0.767292,-0.74084 0.370417,0 0.740833,0.3175 0.767292,0.71438 0.661458,-0.50271 1.481666,-0.76729 2.38125,-0.76729 2.090208,0 3.96875,1.64041 3.96875,3.70416 v 4.81542 c 0,0.39687 -0.370417,0.74083 -0.767292,0.74083 -0.423333,0 -0.767292,-0.34396 -0.767292,-0.74083 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m -104.76366,196.69457 c -0.0265,-2.38125 -2.14312,-4.39208 -4.65667,-4.39208 -2.61937,0 -4.68312,2.0902 -4.68312,4.65666 0,2.61938 2.09021,4.68313 4.68312,4.68313 1.24355,0 2.40771,-0.47625 3.25438,-1.32292 0.15875,-0.13229 0.26458,-0.37042 0.26458,-0.58208 0,-0.42334 -0.37041,-0.76729 -0.76729,-0.76729 -0.23812,0 -0.44979,0.13229 -0.60854,0.3175 -0.52917,0.55562 -1.29646,0.8202 -2.11667,0.8202 -1.56104,0 -2.83104,-1.05833 -3.09562,-2.54 h 6.985 c 0,0 0,0 0.0265,0 h 0.0264 c 0,0 0.0265,0 0.0265,0 0.0265,0 0.0529,0 0.0794,-0.0265 0.3175,-0.1323 0.58208,-0.4498 0.58208,-0.84667 z m -4.65667,-2.8575 c 1.4023,0 2.56646,0.89958 2.96334,2.16958 h -5.95313 c 0.39688,-1.27 1.56104,-2.16958 2.98979,-2.16958 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m -76.929492,196.69457 c -0.02646,-2.38125 -2.169584,-4.39208 -4.656667,-4.39208 -2.619375,0 -4.683125,2.0902 -4.683125,4.65666 0,2.61938 2.090208,4.68313 4.683125,4.68313 1.243542,0 2.407708,-0.47625 3.254375,-1.32292 0.15875,-0.13229 0.264583,-0.37042 0.264583,-0.58208 0,-0.42334 -0.370416,-0.76729 -0.767291,-0.76729 -0.238125,0 -0.449792,0.13229 -0.608542,0.3175 -0.529167,0.55562 -1.296458,0.8202 -2.116667,0.8202 -1.561041,0 -2.831041,-1.05833 -3.095625,-2.54 h 6.985 c 0,0 0,0 0.02646,0 h 0.02646 c 0.02646,0 0.05292,0 0.05292,0 0,0 0.02646,0 0.02646,0 0.3175,-0.13229 0.608542,-0.47625 0.608542,-0.87312 z m -4.656667,-2.8575 c 1.402292,0 2.566458,0.89958 2.963333,2.16958 h -5.953125 c 0.396875,-1.27 1.561042,-2.16958 2.989792,-2.16958 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m -46.290743,201.5629 c -0.07937,0 -0.132291,-0.0529 -0.132291,-0.13229 v -1.29646 h -0.291042 c -0.07937,0 -0.132292,-0.0529 -0.132292,-0.13229 0,-0.0794 0.05292,-0.13229 0.132292,-0.13229 h 0.846667 c 0.07937,0 0.132291,0.0529 0.132291,0.13229 0,0.0794 -0.05292,0.13229 -0.132291,0.13229 h -0.291042 v 1.29646 c 0,0.0794 -0.05292,0.13229 -0.132292,0.13229 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m -44.782618,201.5629 c -0.07937,0 -0.105833,-0.0529 -0.132291,-0.10583 l -0.370417,-1.05833 v 1.03187 c 0,0.0794 -0.05292,0.13229 -0.132292,0.13229 -0.07938,0 -0.132291,-0.0529 -0.132291,-0.13229 v -1.37583 c 0,-0.10584 0.07937,-0.18521 0.185208,-0.18521 0.07937,0 0.15875,0.0529 0.185208,0.13229 l 0.370417,1.08479 0.370417,-1.08479 c 0.02646,-0.0794 0.105833,-0.13229 0.185208,-0.13229 0.105833,0 0.185208,0.0794 0.185208,0.18521 v 1.37583 c 0,0.0794 -0.05292,0.13229 -0.132291,0.13229 -0.07938,0 -0.132292,-0.0529 -0.132292,-0.13229 v -1.03187 c -0.05292,0.15875 -0.132292,0.42333 -0.211667,0.635 -0.132291,0.42333 -0.15875,0.42333 -0.15875,0.42333 0.02646,0.0794 -0.02646,0.10583 -0.07937,0.10583 z",
    className: "st4",
    style: {
      fill: "#26478d",
      strokeWidth: 0.26458332
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style10",
    type: "text/css"
  }, "#experianLogo .st0{fill:#406EB3;} #experianLogo .st1{fill:#632678;} #experianLogo .st2{fill:#982881;} #experianLogo .st3{fill:#BA2F7D;} #experianLogo .st4{fill:#26478D;} #experianLogo .st5{fill:none;}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperianLogo);
export default __webpack_public_path__ + "static/media/experian-logo.bd28299af8203985332e3842dedc3e8e.svg";
export { ForwardRef as ReactComponent };